import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import About from '../pages/About';
import Services from '../pages/Services';
import Main from '../pages/Main'
import Contact from '../pages/Contact/Contact'
import Materials from '../pages/Tests/Materials';
import TestTaking from '../pages/TestTaking/TestTaking';
import TestResults from '../pages/TestResults/TestResults';
import ExerciseDetail from '../pages/ExerciseDetail/ExerciseDetail';
import PostDetail from '../pages/PostDetail/PostDetail';

const Content: React.FC = () => {
    return (
        <main>
            <Routes>
                <Route path="/" Component={Main} />
                <Route path="/about" Component={About} />
                <Route path="/services" Component={Services} />
                <Route path="/materials" Component={Materials} />
                <Route path="/materials/tests" Component={Materials} />
                <Route path="/materials/exercises" Component={Materials} />
                <Route path="/materials/articles" Component={Materials} />
                <Route path="/materials/article/:postId" Component={PostDetail} />
                <Route path="/tests" element={<Navigate to="/materials" replace />} />
                <Route path="/materials/test/:testId" Component={TestTaking} />
                <Route path="/tests/:testId" element={<Navigate to="/materials/test/:testId" replace />} />
                <Route path="/materials/exercise/:exerciseId" Component={ExerciseDetail} />
                <Route path="/materials/test/:testId/results" Component={TestResults} />
                <Route path="/tests/:testId/results" element={<Navigate to="/materials/test/:testId/results" replace />} />
                <Route path="/contact" Component={Contact} />
            </Routes>
        </main>
    );
};

export default Content;
